/* Campaign article sections (campaign-*). Vanilla JS, no dependencies.
 * All visible strings come from data-* attributes rendered from section/block settings. */
(function () {
	if (window.CampaignArticle) return;

	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	var GREEK = {
		'α': 'a', 'β': 'v', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'i', 'θ': 'th', 'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm',
		'ν': 'n', 'ξ': 'x', 'ο': 'o', 'π': 'p', 'ρ': 'r', 'σ': 's', 'ς': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'ch', 'ψ': 'ps', 'ω': 'o'
	};

	function now() {
		return Date.now();
	}

	function slugify(text) {
		var s = (text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
		s = s.replace(/[α-ως]/g, function (c) { return GREEK[c] || ''; });
		return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
	}

	/* ---------- Heading ids (unique per page) ---------- */
	function assignHeadingIds() {
		var used = {};
		document.querySelectorAll('[id]').forEach(function (el) {
			if (!el.hasAttribute('data-campaign-heading')) used[el.id] = true;
		});
		document.querySelectorAll('[data-campaign-heading]').forEach(function (h) {
			var base = h.getAttribute('data-anchor') || slugify(h.textContent) || h.id;
			var id = base;
			var i = 2;
			while (used[id]) id = base + '-' + i++;
			used[id] = true;
			if (h.id !== id) {
				var old = h.id;
				h.id = id;
				document.querySelectorAll('[aria-labelledby="' + old + '"]').forEach(function (s) { s.setAttribute('aria-labelledby', id); });
			}
		});
	}

	function scrollToTarget(el) {
		el.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
		if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
		el.focus({ preventScroll: true });
		if (history.replaceState) history.replaceState(null, '', '#' + el.id);
	}

	/* ---------- TOC ---------- */
	var tocObserver = null;

	function buildToc() {
		var root = document.querySelector('[data-campaign-toc]');
		if (!root) return;
		var nav = root.querySelector('[data-toc-nav]');
		var list = root.querySelector('[data-toc-list]');
		var toggle = root.querySelector('[data-toc-toggle]');
		if (!nav || !list) return;
		var withH3 = root.getAttribute('data-levels') === 'h2h3';

		var headings = Array.prototype.filter.call(document.querySelectorAll('[data-campaign-heading]'), function (h) {
			if (h.getAttribute('data-toc') === 'false') return false;
			return h.tagName === 'H2' || (withH3 && h.tagName === 'H3');
		});

		list.innerHTML = '';
		headings.forEach(function (h) {
			var li = document.createElement('li');
			li.className = 'campaign-toc__item campaign-toc__item--' + h.tagName.toLowerCase();
			var a = document.createElement('a');
			a.href = '#' + h.id;
			a.textContent = h.getAttribute('data-toc-label') || h.textContent.trim();
			a.addEventListener('click', function (e) {
				e.preventDefault();
				scrollToTarget(h);
				if (toggle && !isFixedToc(nav)) setTocOpen(root, false);
			});
			li.appendChild(a);
			list.appendChild(li);
		});
		nav.hidden = headings.length === 0;

		if (toggle && !toggle._campaignBound) {
			toggle._campaignBound = true;
			toggle.addEventListener('click', function () {
				setTocOpen(root, toggle.getAttribute('aria-expanded') !== 'true');
			});
		}
		setTocOpen(root, false);

		if (tocObserver) tocObserver.disconnect();
		if (!('IntersectionObserver' in window)) return;
		tocHeadings = headings;
		tocList = list;
		tocObserver = new IntersectionObserver(requestScroll, { rootMargin: '0px 0px -60% 0px' });
		headings.forEach(function (h) { tocObserver.observe(h); });
		last = {};
		requestScroll();
	}

	var tocHeadings = [];
	var tocList = null;

	function setTocOpen(root, open) {
		var toggle = root.querySelector('[data-toc-toggle]');
		var list = root.querySelector('[data-toc-list]');
		if (!toggle || !list) return;
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		list.hidden = !open && !isFixedToc(root.querySelector('[data-toc-nav]'));
	}

	function isFixedToc(nav) {
		return !!nav && getComputedStyle(nav).position === 'fixed';
	}

	// Bottom edge of the theme's sticky/fixed header group while it is pinned to the top.
	function headerBottom() {
		var bottom = 0;
		document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
			var pos = getComputedStyle(el).position;
			if (pos !== 'sticky' && pos !== 'fixed') return;
			var r = el.getBoundingClientRect();
			if (r.height > 0 && r.top <= 1 && r.bottom > bottom) bottom = r.bottom;
		});
		return bottom;
	}

	/* ---------- Scroll-driven: scroll-spy, progress bar, desktop TOC, sticky CTA ----------
	 * One rAF per scroll burst. Phase 1 only measures, phase 2 only writes, and writes happen
	 * only when a value changes, so scrolling never forces extra layout passes. */
	var ctaVisible = false;
	var ticking = false;
	var TOC_GAP = 24;
	var TOC_MIN = 160;
	var last = {};

	function setIfChanged(key, value, apply) {
		if (last[key] === value) return;
		last[key] = value;
		apply(value);
	}

	function measure(root) {
		var vh = window.innerHeight;
		var m = { vh: vh, y: window.scrollY, line: vh * 0.35, active: null };
		tocHeadings.forEach(function (h) { if (h.getBoundingClientRect().top <= m.line) m.active = h.id; });

		var body = document.querySelectorAll('[data-campaign-body]');
		if (body.length) {
			m.bodyTop = body[0].getBoundingClientRect().top + m.y;
			m.bodyBottom = body[body.length - 1].getBoundingClientRect().bottom + m.y;
		}
		m.maxScroll = document.documentElement.scrollHeight - vh;

		var nav = root.querySelector('[data-toc-nav]');
		m.fixed = isFixedToc(nav);
		if (m.fixed) {
			// The lane sections (content, stats, cards) are the only place the fixed TOC may appear.
			var lane = document.querySelectorAll('[data-campaign-body]:not([data-campaign-timeline])');
			if (lane.length) {
				var container = lane[0].querySelector('.campaign-container');
				m.left = container ? Math.round(container.getBoundingClientRect().left) : null;
				m.top = Math.round(headerBottom() + TOC_GAP);
				m.first = lane[0].getBoundingClientRect().top;
				m.room = Math.floor(Math.min(vh - m.top - TOC_GAP, lane[lane.length - 1].getBoundingClientRect().bottom - TOC_GAP - m.top));
			}
		}
		return m;
	}

	function onScroll() {
		ticking = false;
		var root = document.querySelector('[data-campaign-toc]');
		if (!root) return;
		var m = measure(root);

		if (tocList) {
			setIfChanged('active', m.active, function (id) {
				tocList.querySelectorAll('a').forEach(function (a) {
					if (id && a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true');
					else a.removeAttribute('aria-current');
				});
			});
		}

		var bar = root.querySelector('[data-progress-bar]');
		if (bar && m.bodyTop !== undefined) {
			var total = Math.max(1, m.bodyBottom - m.bodyTop - m.vh * 0.5);
			var p = Math.min(1, Math.max(0, (m.y + m.vh * 0.25 - m.bodyTop) / total));
			setIfChanged('progress', p.toFixed(3), function (v) { bar.style.transform = 'scaleX(' + v + ')'; });
		}

		var nav = root.querySelector('[data-toc-nav]');
		if (nav) {
			if (!m.fixed || m.top === undefined) {
				setIfChanged('tocVisible', false, function () { nav.classList.remove('campaign-is-visible'); });
				setIfChanged('tocBox', '', function () { nav.style.top = nav.style.left = nav.style.maxHeight = ''; });
			} else {
				var visible = m.first <= m.top && m.room >= TOC_MIN;
				var box = m.top + '|' + m.left + '|' + (visible ? m.room : '');
				setIfChanged('tocBox', box, function () {
					nav.style.top = m.top + 'px';
					if (m.left !== null) nav.style.left = m.left + 'px';
					if (visible) nav.style.maxHeight = m.room + 'px';
				});
				setIfChanged('tocVisible', visible, function (v) { nav.classList.toggle('campaign-is-visible', v); });
			}
		}

		var sticky = root.querySelector('[data-sticky-cta]');
		if (sticky) {
			var threshold = parseFloat(sticky.getAttribute('data-threshold')) || 30;
			var show = (m.y / Math.max(1, m.maxScroll)) * 100 >= threshold && !ctaVisible;
			setIfChanged('sticky', show, function (v) {
				sticky.classList.toggle('campaign-is-visible', v);
				sticky.setAttribute('aria-hidden', v ? 'false' : 'true');
				sticky.querySelectorAll('a').forEach(function (a) { a.tabIndex = v ? 0 : -1; });
			});
		}
	}

	function requestScroll() {
		if (!ticking) {
			ticking = true;
			window.requestAnimationFrame(onScroll);
		}
	}

	var ctaObserver = null;
	function watchCta() {
		if (ctaObserver) ctaObserver.disconnect();
		ctaVisible = false;
		if (!('IntersectionObserver' in window)) return;
		var ctas = document.querySelectorAll('[data-campaign-cta]');
		if (!ctas.length) return;
		var visible = new Set();
		ctaObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
			ctaVisible = visible.size > 0;
			requestScroll();
		});
		ctas.forEach(function (c) { ctaObserver.observe(c); });
	}

	/* ---------- Countdown ---------- */
	function pad(n) { return (n < 10 ? '0' : '') + n; }

	function initCountdown(el) {
		if (el._campaignTimer) clearInterval(el._campaignTimer);
		var target = Date.parse(el.getAttribute('data-target'));
		var end = Date.parse(el.getAttribute('data-end'));
		if (isNaN(target)) { el.hidden = true; return; }
		if (isNaN(end)) end = target;
		var timer = el.querySelector('[data-countdown-timer]');
		var live = el.querySelector('[data-countdown-live]');
		var title = el.querySelector('[data-countdown-title]');
		var sr = el.querySelector('[data-countdown-sr]');
		var nums = {
			d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'),
			m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]')
		};
		var labels = {
			d: el.getAttribute('data-label-d') || '', h: el.getAttribute('data-label-h') || '', m: el.getAttribute('data-label-m') || ''
		};
		var lastMinute = null;

		function tick() {
			var t = now();
			if (t > end) {
				el.hidden = true;
				clearInterval(el._campaignTimer);
				return 'after';
			}
			el.hidden = false;
			if (t >= target) {
				if (timer) timer.hidden = true;
				if (title) title.hidden = true;
				if (live) live.hidden = false;
				if (sr && lastMinute !== 'during') { sr.textContent = live ? live.textContent : ''; lastMinute = 'during'; }
				return 'during';
			}
			if (timer) timer.hidden = false;
			if (title) title.hidden = false;
			if (live) live.hidden = true;
			var diff = Math.floor((target - t) / 1000);
			var d = Math.floor(diff / 86400);
			var h = Math.floor((diff % 86400) / 3600);
			var m = Math.floor((diff % 3600) / 60);
			var s = diff % 60;
			if (nums.d) nums.d.textContent = d;
			if (nums.h) nums.h.textContent = pad(h);
			if (nums.m) nums.m.textContent = pad(m);
			if (nums.s) nums.s.textContent = pad(s);
			var minuteKey = d + ':' + h + ':' + m;
			if (sr && minuteKey !== lastMinute) {
				lastMinute = minuteKey;
				sr.textContent = (title ? title.textContent.trim() + ' ' : '') + d + ' ' + labels.d + ', ' + h + ' ' + labels.h + ', ' + m + ' ' + labels.m;
			}
			return 'before';
		}

		if (tick() !== 'after') el._campaignTimer = setInterval(tick, 1000);
		return tick;
	}

	/* ---------- Stats count-up ---------- */
	function initStats(root) {
		var values = root.querySelectorAll('[data-count]');
		if (!values.length) return;
		if (root.getAttribute('data-animate') !== 'true' || reducedMotion.matches || !('IntersectionObserver' in window)) return;
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				animateValue(entry.target);
			});
		}, { threshold: 0.4 });
		values.forEach(function (v) {
			var final = v.textContent;
			var n = parseFloat(v.getAttribute('data-count'));
			if (isNaN(n) || !/\d/.test(final)) return;
			v._campaignFinal = final;
			v.textContent = final.replace(/\d+([.,]\d+)?/, '0');
			io.observe(v);
		});
	}

	function animateValue(el) {
		var n = parseFloat(el.getAttribute('data-count'));
		var final = el._campaignFinal;
		var start = null;
		var duration = 1200;
		function step(ts) {
			if (start === null) start = ts;
			var p = Math.min(1, (ts - start) / duration);
			var eased = 1 - Math.pow(1 - p, 3);
			el.textContent = final.replace(/\d+([.,]\d+)?/, String(Math.round(n * eased)));
			if (p < 1) window.requestAnimationFrame(step);
			else el.textContent = final;
		}
		window.requestAnimationFrame(step);
		setTimeout(function () { el.textContent = final; start = -Infinity; }, duration + 200);
	}

	/* ---------- Timeline ---------- */
	function todayIn(tz) {
		var fmt;
		try {
			fmt = new Intl.DateTimeFormat('en-CA', { timeZone: tz || 'Europe/Athens', year: 'numeric', month: '2-digit', day: '2-digit' });
		} catch (e) {
			fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' });
		}
		return fmt.format(new Date(now()));
	}

	function initTimeline(root) {
		var today = todayIn(root.getAttribute('data-timezone'));
		var current = null;
		var items = root.querySelectorAll('[data-period]');
		items.forEach(function (item) {
			item.classList.remove('campaign-is-current');
			item.removeAttribute('aria-current');
			var badge = item.querySelector('[data-period-badge]');
			if (badge) badge.hidden = true;
			var s = item.getAttribute('data-start');
			var e = item.getAttribute('data-end') || s;
			if (!/^\d{4}-\d{2}-\d{2}$/.test(s) || !/^\d{4}-\d{2}-\d{2}$/.test(e)) return;
			if (today >= s && today <= e && (!current || s >= current.getAttribute('data-start'))) current = item;
		});
		if (current) {
			current.classList.add('campaign-is-current');
			current.setAttribute('aria-current', 'step');
			var b = current.querySelector('[data-period-badge]');
			if (b) b.hidden = false;
		}
		return current;
	}

	/* ---------- Share ---------- */
	function initShare(root) {
		var btn = root.querySelector('[data-copy-link]');
		if (!btn || btn._campaignBound) return;
		btn._campaignBound = true;
		var status = root.querySelector('[data-copy-status]');
		btn.addEventListener('click', function () {
			var url = btn.getAttribute('data-url') || window.location.href;
			var done = function () {
				if (!status) return;
				status.textContent = btn.getAttribute('data-success') || '';
				clearTimeout(btn._campaignT);
				btn._campaignT = setTimeout(function () { status.textContent = ''; }, 4000);
			};
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
			} else {
				fallbackCopy(url);
				done();
			}
		});
	}

	function fallbackCopy(text) {
		var ta = document.createElement('textarea');
		ta.value = text;
		ta.setAttribute('readonly', '');
		ta.style.position = 'absolute';
		ta.style.left = '-9999px';
		document.body.appendChild(ta);
		ta.select();
		try { document.execCommand('copy'); } catch (e) {}
		document.body.removeChild(ta);
	}

	/* ---------- Init ---------- */
	// Every campaign section links the shared CSS/JS so each section also works on its own.
	// Keep only the first copy of each, so the stylesheet is not held in the CSSOM once per section.
	function dedupeAssets() {
		var seen = {};
		document.querySelectorAll('link[rel="stylesheet"][href*="campaign-article."], script[src*="campaign-article."]').forEach(function (el) {
			var key = (el.href || el.src).split('?')[0];
			if (seen[key]) el.parentNode.removeChild(el);
			else seen[key] = true;
		});
	}

	function initAll() {
		dedupeAssets();
		assignHeadingIds();
		document.querySelectorAll('[data-campaign-countdown]').forEach(initCountdown);
		document.querySelectorAll('[data-campaign-stats]').forEach(initStats);
		document.querySelectorAll('[data-campaign-timeline]').forEach(initTimeline);
		document.querySelectorAll('[data-campaign-share]').forEach(initShare);
		buildToc();
		watchCta();
		requestScroll();
	}

	window.addEventListener('scroll', requestScroll, { passive: true });
	window.addEventListener('resize', requestScroll);
	var lastFixed = null;
	window.addEventListener('resize', function () {
		var root = document.querySelector('[data-campaign-toc]');
		if (!root) return;
		var fixed = isFixedToc(root.querySelector('[data-toc-nav]'));
		if (fixed !== lastFixed) { lastFixed = fixed; setTocOpen(root, false); }
	});
	document.addEventListener('shopify:section:load', initAll);
	document.addEventListener('shopify:section:unload', function () { setTimeout(initAll, 0); });
	document.addEventListener('shopify:section:reorder', initAll);
	document.addEventListener('shopify:block:select', function (e) {
		if (e.target && e.target.matches && e.target.matches('[data-campaign-heading]')) buildToc();
	});

	window.CampaignArticle = { init: initAll, slugify: slugify, initCountdown: initCountdown, initTimeline: initTimeline, todayIn: todayIn };

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
	else initAll();
})();
